// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import LeftIcon from '@mui/icons-material/ChevronLeft'
import RightIcon from '@mui/icons-material/ChevronRight'
import IconButton from '@mui/material/IconButton'
import moment from 'moment'
import css from './BudgetPlanning.css'
import { Button } from '@mui/material'
import { i18n } from '../index'
type MonthDisplayProps = {
  currentMonth: number
  onMonthChange: (...args: Array<any>) => any
}

const MonthDisplay = ({
  currentMonth,
  onMonthChange,
  isStationPage,
  editable,
  toggleEditMode,
  onMutate,
  startDate,
}: MonthDisplayProps) => {
  const date = moment(startDate)
  const now = moment()

  const onClick = () => {
    // send mutation if the page is on edit mode and the button is clicked
    editable && onMutate()
    toggleEditMode()
  }

  return (
    <div className={css.monthDisplay}>
      {isStationPage && (
        <div className={css.indexContainer}>
          {editable && (
            <Button onClick={toggleEditMode} variant='contained' color='secondary' className={css.cancelButton}>
              {i18n.t('buttons.cancel')}
            </Button>
          )}
          <Button
            onClick={onClick}
            variant='contained'
            color='primary'
            disabled={!date.isSame(now, 'month') && date.isBefore(now, 'month')}
            className={css.acceptButton}
          >
            {editable ? i18n.t('buttons.save') : i18n.t('buttons.edit')}
          </Button>
        </div>
      )}
      <IconButton className={css.monthButton} onClick={() => onMonthChange(-1)}>
        <LeftIcon />
      </IconButton>
      <div className={css.month}>
        {moment()
          .startOf('year')
          .add(currentMonth - 1, 'months')
          .format('MMMM YYYY')}
      </div>
      <IconButton className={css.monthButton} onClick={() => onMonthChange(1)}>
        <RightIcon />
      </IconButton>
    </div>
  )
}

export default MonthDisplay
